<template>
  <teleport to=".main-wrapper">
    <FadeTransition :duration="duration" appear>
      <div v-if="isOpen" key="modal-wrapper" class="modal-wrapper">
        <ModalHeader
          :title="headerModel.title"
          :height="$isAndroid ? 56 : 50"
          @head-click="closeModal"
        >
          <template v-if="$slots.head" #head>
            <slot name="head"></slot>
          </template>
          <template v-if="$slots.title" #title>
            <slot name="title"></slot>
          </template>
          <template v-if="$slots.tail" #tail>
            <slot name="tail"></slot>
          </template>
        </ModalHeader>
        <slot :close="closeModal"></slot>
      </div>
    </FadeTransition>
  </teleport>
</template>

<script>
import ModalHeader from "@/components/shared/header/PageModalHeader.vue";
import FadeTransition from "@/components/shared/transitions/FadeTransition.vue";
import useModalNav from "@/composables/useModalNavigation";

export default {
  components: {
    ModalHeader,
    FadeTransition,
  },
  name: "ModalWindow",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    headerModel: {
      type: [Object, null],
      required: true,
    },
    duration: {
      type: [String, Number],
      default: "150",
    },
  },
  emits: ["update:isOpen"],
  setup(props, { emit }) {
    return useModalNav(props, emit);
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  padding-bottom: 10px;
  width: 100vw;
  min-height: 100vh;
  z-index: 100;
  left: 0;
  top: 0;
  overflow-y: scroll;
  background-color: #f0f0f0;

  &__header {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    width: 100vw;
    overflow: hidden;
    z-index: 5;
  }

  &.blur {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  &__close-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 78px;
    height: 78px;
    z-index: inherit;
  }
}
</style>
